/*
 FormEntryDialog.js component
 url match: / or /login
 Displays email id and password field
 with FormEntryDialog button
*/
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import { formStyles } from '../../Styles/formStyles';

import { ReactSVG } from 'react-svg'
import Images from '../../Theme/Images';
import TextField from '@material-ui/core/TextField';


@inject('documentStore')
@observer
class FormEntryDialog extends React.Component {

    handleFormFieldChange = (value, index, fieldId, type) => {
        if (this.props.type === 'poso')
            this.props.documentStore.updatePosoField(value, index, fieldId)
        else
            this.props.documentStore.updateField(value, index, fieldId, type)
    }

    updateForm = () => {
        const { disableCropping } = this.props.documentStore
        if (disableCropping.findIndex(x => x === this.props.documentStore.currentDoc.docType) > -1)
            return
        const { currentField } = this.props.documentStore;
        if (this.props.type === 'poso')
            this.props.documentStore.updatePosoDocument(currentField)
        else
            this.props.documentStore.updateForm()
        this.props.documentStore.resetCurrentField();
        this.props.cancelZoom()
    }

    onCancel = (index) => {
        const { disableCropping } = this.props.documentStore
        if (disableCropping.findIndex(x => x === this.props.documentStore.currentDoc.docType) > -1)
            return
        if (this.props.type === 'poso')
            this.props.documentStore.undoPosoChanges(index);
        else
            this.props.documentStore.undoChanges(index);
        this.props.documentStore.resetCurrentField();
        this.props.cancelZoom()
    }

    render() {
        const { classes, type } = this.props;
        const { currentField, currentIndex } = this.props.documentStore;
        return (
            currentField._id !== undefined ? <div className={classes.fieldDiv} style={{ display: currentField.style.display, top: currentField.style.top, left: currentField.style.left }}>
                <p id="fieldLabel" className={classes.fieldLabel}>{type === 'poso' ? currentField.aiKey : currentField.label}</p>
                <div id="hiddenText" className={classes.hiddenText}>{currentField.editedValue !== "" && currentField.editedValue !== undefined ? currentField.editedValue : currentField.aiValue}</div>
                <TextField multiline id="outlined-basic" fullWidth value={currentField.editedValue !== "" && currentField.editedValue !== undefined ? currentField.editedValue : currentField.aiValue}
                    InputProps={{ disableUnderline: true, classes: { input: classes.textFieldInput, multiline: classes.multiline } }}
                    variant="filled"
                    onChange={(event) => this.handleFormFieldChange(event.target.value, currentIndex, currentField._id, currentField.editedValue !== "" && currentField.editedValue !== undefined ? "editedValue" : "aiValue")}
                />
                <div id="fieldIconContainer" className={classes.fieldIconContainer}>
                    <ReactSVG onClick={(e) => this.onCancel(currentIndex)} src={Images.cancel} beforeInjection={svg => { svg.classList.add(classes.formIcons) }} />
                    <ReactSVG onClick={(e) => this.updateForm()} src={Images.docRight} beforeInjection={svg => { svg.classList.add(classes.formIcons) }} />
                </div>
            </div> : null
        )

    }
}
export default withStyles(formStyles, { withTheme: true })(withRouter(FormEntryDialog));


